import { render, staticRenderFns } from "./HavaleAutomatic.vue?vue&type=template&id=c0f4d89a&"
import script from "./HavaleAutomatic.vue?vue&type=script&lang=js&"
export * from "./HavaleAutomatic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports